import React, { useState, useEffect } from 'react';
import "../Admin/assete/css/detailsview.css";
import Sidebar from './Siderbar';
import { ViewDetailsApi , deleteDetailApi, updateReadStatusApi,updateContactMessageApi} from '../service/Api';
import Adminheader from './Adminheader';



const Detailsview = () => {
        const [details, setDetails] = useState([]);
        const [showPopup, setShowPopup] = useState(false);
        const [detailToDelete, setDetailToDelete] = useState(null);
          const [editRewriteMessages, setEditRewriteMessages] = useState({});
          const [editMode, setEditMode] = useState({});
        const moment = require('moment-timezone');
const nowInKolkata = moment().tz('Asia/Kolkata');

console.log(nowInKolkata.format('YYYY-MM-DD h:m:i'));

    
       useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await ViewDetailsApi();
      if (response && response.contact_details) {
        const detailsData = response.contact_details.reverse();
        setDetails(detailsData);

        // Initialize editRewriteMessages with existing rewrite
        const initialRewrites = {};
        detailsData.forEach(d => {
          initialRewrites[d.id] = d.rewrite || "";
        });
        setEditRewriteMessages(initialRewrites);

      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  fetchData();
}, []);

    
        const handleDelete = async () => {
            try {
                await deleteDetailApi(detailToDelete);
                setDetails(details.filter(detail => detail.id !== detailToDelete));
                setShowPopup(false);
            } catch (error) {
                console.error('Error deleting detail:', error);
            }
        };
    
        const openDeletePopup = (id) => {
            setDetailToDelete(id);
            setShowPopup(true);
        };
    
        const closeDeletePopup = () => {
            setShowPopup(false);
        };
    
        const markAsRead = async (id, currentStatus) => {
          try {
            const newStatus = currentStatus === "read" ? "unread" : "read";
            // Call the API to update the read status
            const response = await updateReadStatusApi(id, newStatus);
            if (response && response.status) {
              // Update the local state to reflect the change
              setDetails((prevDetails) =>
                prevDetails.map((detail) =>
                  detail.id === id ? { ...detail, readed: newStatus  } : detail
                )
              );
            } else {
              console.error("Failed to update read status");
            }
          } catch (error) {
            console.error("Error marking as read:", error);
          }
        };


      // Add these functions inside your component (before the return statement)
const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid Date';
    
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    
    return `${day}-${month}-${year}`;
};

const formatTime = (timeString) => {
    if (!timeString || typeof timeString !== 'string') return 'N/A';
    const parts = timeString.split(':');
    if (parts.length < 2) return 'N/A'; // Must have at least hours and minutes
    const [hours, minutes] = parts;
    const hour = parseInt(hours, 10);
    if (isNaN(hour)) return 'N/A';
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes.padStart(2, '0')} ${ampm}`;
};

const handleEditClick = (id) => {
  setEditMode(prev => ({ ...prev, [id]: true }));
  // Set textarea to current rewrite if not already
  setEditRewriteMessages(prev => ({ ...prev, [id]: details.find(d => d.id === id)?.rewrite || "" }));
};

   const handleEditChange = (id, value) => {
        setEditRewriteMessages(prev => ({ ...prev, [id]: value }));
    };

    const handleSave = async (id) => {
        try {
            const newMessage = editRewriteMessages[id];
            if (!newMessage || newMessage.trim() === "") {
                alert("rewrite cannot be empty");
                return;
            }

            const response = await updateContactMessageApi(id, newMessage);
            if (response && response.status) {
                // Update local state
                setDetails(prevDetails =>
                    prevDetails.map(detail =>
                        detail.id === id ? { ...detail, rewrite: newMessage } : detail
                    )
                );
                 setEditMode(prev => ({ ...prev, [id]: false }));
                 setEditRewriteMessages(prev => ({ ...prev, [id]: "" }));
                alert("rewrit updated successfully!");
            } else {
                alert("Failed to update message");
            }
        } catch (error) {
            console.error("Error updating message:", error);
        }
    };


        const sortedDetails = [...details].sort((a, b) => {
          if (a.readed === "read" && b.readed !== "read") return 1;
          if (a.readed !== "read" && b.readed === "read") return -1;
          return 0;
        });
        const unreadCount = details.filter(detail => detail.readed !== "read").length;
  return (
    <>
     <div className='body-div'>
        <Adminheader unreadCount={unreadCount}/>
        <div className='container_dashboard'>
            <div className='index-content'>
                <Sidebar/>
                <div className='dashboard_main_div '>
                <div className='dashboard_div'>
                  <div className='conts_consts'>
                    <h2>Contact Deatils</h2>
                  </div>
                <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Service Type</th>
                            <th>Message</th>
                            <th>Date</th>
                            <th>Time</th>
                             <th>Remark</th>
                            <th>View</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedDetails.map((detail, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{detail.name}</td>
                                <td>{detail.email}</td>
                                <td>{detail.phone}</td>
                                <td>{detail.service_type}</td>
                                <td style={{ maxWidth: '180px', maxHeight: '100px', overflow: 'auto' }}>{detail.message}</td>
                                <td>{formatDate(detail.date)}</td>
                          <td>{formatTime(detail.time)}</td>
                           <td>
                             {editMode[detail.id] ? (
                              <>
                                  <textarea
                                            value={editRewriteMessages[detail.id] || ""}
                                            onChange={(e) => handleEditChange(detail.id, e.target.value)}
                                            placeholder="Rewrite message"
                                            style={{ width: '100px', height: '60px',resize: 'none',overflow: 'auto' }}
                                        />
                                         <br />
                                        <button
                                        type="button"
                                            onClick={() => handleSave(detail.id)}
                                            style={{ backgroundColor: 'blue', color: 'white', padding: '4px 4px', marginTop: '5px' }}
                                        >
                                            Save
                                        </button>
                                        
                                    </>
  ) : (
    <>
     <div
        style={{
          width: '100px',
          height: '50px',
          overflow: 'auto',        // scroll if text is too long
          whiteSpace: 'pre-wrap',  // wrap long lines
          wordBreak: 'break-word', // break long words
          border: '1px solid #ddd', // optional: border to visualize cell
          padding: '2px', fontSize:"12px"
        }}
      >
        {detail.rewrite || "N/A"}
      </div>
      <br />
      <button
      type="button"
        onClick={() => handleEditClick(detail.id)}
        style={{ backgroundColor: 'orange', color: 'white', padding: '4px 8px', marginTop: '5px' }}
      >
        Edit
      </button>
    </>
  )}
</td>

                                <td>  <button 
                                type="button"
    onClick={() => markAsRead(detail.id, detail.readed)}
    style={{
      backgroundColor: detail.readed === "read" ? "green" : "orange",
      color: "white",
      border: "none",
      padding: "5px 10px",
      cursor: "pointer"
    }}
  >
    {detail.readed === "read" ? "Read" : "Unread"}
  </button></td>
                                <td><button type="button" onClick={() => openDeletePopup(detail.id)}>Delete</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
                    </div>
                  
                    </div>

                </div>
            </div>


    </div>
    {showPopup && (
                <div className="popup-container">
                    <div className="popup">
                        <h3>Are you sure you want to delete?</h3>
                        <div className="popup-buttons">
                            <button onClick={handleDelete}>Delete</button>
                            <button onClick={closeDeletePopup}>Cancel</button>
                        </div>
                    </div>
                </div>
                 
            )}
    </>
  )
}

export default Detailsview